<template>
  <h1
    class="primary--text"
    data-cy="titulo_pagina"
    :class="$vuetify.breakpoint.lgAndUp ? 'display-1' : 'headline'"
  >
    {{ titulo }}
  </h1>
</template>

<script>
export default {
  name: 'TituloPagina',

  props: {
    titulo: {
      type: String,
      required: true,
    },
  },
};
</script>
